module.exports = __webpack_public_path__ + "images/emoji/ramen.3ebc84cf173e8aa75902.png";